import React, { useState, useEffect, useReducer } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import {
} from '@mui/material';

import CustomBackdrop from '../../../../../components/CustomBackdrop';

import { sectionReducer, SectionReducerAction } from '../Common';
import Steps from '../Common/components/Steps';

import { editSectionInitQuery } from './queries';
import { updateSection } from './mutations';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>,
  section_id: string,
  handleFinish: () => void,
}

const EditSection = ({ classes, history, section_id, handleFinish }: Props): React.ReactElement => {

  const [section, dispatchSection] = useReducer(sectionReducer, {
    name: '',
    phone: '',
  });

  const [saving, setSaving] = useState<boolean>(false);

  const { data: editAreaInitData } = useQuery(editSectionInitQuery(section_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && editAreaInitData) {
      dispatchSection({ type: SectionReducerAction.INIT, value: editAreaInitData.area_sections_by_pk });
    }
    return () => { mounted = false; };
  }, [editAreaInitData]);

  const handleSave = async () => {
    setSaving(true);

    const updateVariables = {
      pk_columns: {
        id: section_id,
      },
      set: section,
    };
    await updateSection(updateVariables);

    setSaving(false);
    handleFinish();
  };

  return (
    <>
      <Steps
        completeLabel="Save"
        section={section}
        dispatch={dispatchSection}
        handleSave={handleSave} />
      {saving && <CustomBackdrop label="Saving Changes" />}
    </>
  );
};

export default withRouter(withStyles(styles)(EditSection));
